import { Link } from '@remix-run/react';
import { flushSync } from 'react-dom';
import { openLoyaltySignIn, useLoyaltyShopping } from './loyalty-shopping';

export default function CartRewardsCallout({
  onLeaveCart,
  variant = 'cart',
}: {
  onLeaveCart?: () => void;
  variant?: 'cart' | 'checkout';
}) {
  const { guest } = useLoyaltyShopping();
  if (!guest) return null;

  const signIn = () => {
    // Release the cart's focus trap and higher overlay before opening login.
    if (onLeaveCart) flushSync(onLeaveCart);
    openLoyaltySignIn();
  };

  return (
    <section
      aria-label="Your personalized Catalyst menu"
      className={
        variant === 'checkout'
          ? 'mb-6 rounded-lg bg-[#264B9A] px-4 py-3 text-white'
          : '-mx-4 mb-3 bg-[#264B9A] px-4 py-3 text-white sm:-mx-6 sm:px-6 md:-mx-8 md:px-8'
      }
    >
      <h2 className="font-futura text-lg leading-6 font-bold">Make this menu yours</h2>
      <p className="mt-1 text-xs leading-4 text-white/90">
        {variant === 'checkout'
          ? 'Create an account for a more personal menu next time you shop.'
          : 'Your taste. Your favorites. Sign in for a menu personalized to you.'}
      </p>
      <div className="mt-2 flex items-center gap-3">
        <Link
          to="/register"
          onClick={onLeaveCart}
          className="flex min-h-11 flex-1 items-center justify-center rounded-md bg-[#ffd100] px-3 py-2 text-sm font-bold text-[#14294F] hover:bg-[#ffe066] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          Create my account{' '}
          <span aria-hidden="true" className="ml-2">
            ↗
          </span>
        </Link>
        <button
          type="button"
          onClick={signIn}
          className="min-h-11 shrink-0 rounded-md px-3 py-2 text-sm font-bold text-white underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-[#ffd100]"
        >
          Sign in
        </button>
      </div>
    </section>
  );
}
